const InputError = ({ errorMsg }: { errorMsg?: string }) =>
  errorMsg && (
    <span data-testid="inputError" className="field__error">
      {errorMsg}
    </span>
  );

export default InputError;
